<script setup lang="ts">
import type { AgentExclusivePropertiesSectionSkeletonProps } from '.';

import { cn } from '~/utils';

import AgentCarouselSkeletonFooter from '~/components/Sections/AgentCarouselSkeletonFooter.vue';
import { Skeleton } from '~/components/ui/skeleton';

defineProps<AgentExclusivePropertiesSectionSkeletonProps>();
</script>

<template>
	<section
		:class="
			cn(
				'w-full border-b border-white-dark-3 bg-white pb-8 md:pb-12',
				$props.class
			)
		"
		data-testid="agent-exclusive-properties-section-skeleton"
		aria-busy="true"
		aria-label="Carregando captações exclusivas"
	>
		<div class="mb-6 flex h-9 items-center gap-4 md:h-12" aria-hidden="true">
			<Skeleton
				is-active
				variant="white"
				class="h-[29px] w-7 shrink-0 rounded-none motion-reduce:animate-none"
			/>
			<Skeleton
				is-active
				variant="white"
				class="h-[29px] w-[296px] max-w-[calc(100%-44px)] rounded-none motion-reduce:animate-none"
			/>
		</div>
		<Skeleton
			is-active
			variant="white"
			class="h-[440px] w-full rounded-none motion-reduce:animate-none md:h-[400px] xl:h-[460px]"
			data-testid="agent-exclusive-properties-skeleton"
			aria-hidden="true"
		/>
		<AgentCarouselSkeletonFooter />
	</section>
</template>
